import { BroadcastEvent } from '@core/services';
import { EAsideOutlets } from '../aside-outlets.enum';

export class CloseAsidePageEvent extends BroadcastEvent {
  constructor(public outlet: EAsideOutlets | null = null) {
    super();
  }
}
